export default {"src":"/_next/static/media/mountain-icon.d42f8b84.svg","height":20,"width":20};